import React from 'react';
import PositiveToast from '@/components/toasts/PositiveToast';
import ToastMessage from '@/components/toasts/ToastMessage';

const TasksCompleteToast = ({ items }) => (
  <PositiveToast className="aridhia-tasks-complete-toast">
    <ToastMessage items={items} multiple="toast.tasks.complete" single="toast.task.complete" />
  </PositiveToast>
);

export default TasksCompleteToast;
